var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5003 0.166504C10.0003 0.166504 0.666992 9.49984 0.666992 20.9998C0.666992 32.4998 10.0003 41.8332 21.5003 41.8332C33.0003 41.8332 42.3337 32.4998 42.3337 20.9998C42.3337 9.49984 33.0003 0.166504 21.5003 0.166504ZM23.5837 31.4165H19.417V27.2498H23.5837V31.4165ZM23.5837 23.0832H19.417V10.5832H23.5837V23.0832Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWarningIcon);
export default __webpack_public_path__ + "static/media/modalWarningIcon.edbf47440d00f9e191a3d3fe40846858.svg";
export { ForwardRef as ReactComponent };